import React from 'react';

import Status from './Status';
import EndButton from './EndButton'

export default class EndScreen extends React.Component {

  pushToNewUrl = () => {
    const urlEnd = this.props.langType === 'hu' ? 'blog/' : 'en/blog-2/';
    window.location.assign(`https://www.cx-ray.com/${urlEnd}`);
  };

  render() {
    return (
      <div class='col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 animated fadeIn'>
        <div class='center'
          dangerouslySetInnerHTML={{ __html: this.props.customEndText }} />
        <div class='col-md-12 col-sm-12 col-xs-12 mar20 status-div'>
          <Status {...this.props} />
        </div>
        <EndButton pushToNewUrl={this.pushToNewUrl} endButtonText={this.props.lang.q360_end_close}/>
      </div>
    );
  }
}
